import { HLS_KR, HLS, SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS, HLS];
supported_stream_types.live = [SS, HLS_KR, HLS];
supported_stream_types.timeshift = [SS];

export default {
  appKey: '67943f5a35959548079f77188b781d0b', // TODO ESTO ES DE NAGRA
  appSubkey: 'samsung',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */

  device_manufacturer: 'samsung',
  device_model: 'tizen',
  device_name: 'samsung',
  device_so: deviceInfo.os.description || 'tizen',
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  nodetv: 'tv',
  akamai_id: 'TizenSTV',
  useEpgPostals: true,
  // akamai_mfwk: 'mfwktv2samsung-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2samsung-api.clarovideo.net' : 'http://mfwktv2samsung-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/tizen/config.js